import { resizeAllCharts } from '@hooks/useECharts'

import './PrintButton.css'

export default function PrintButton() {
  const handlePrint = () => {
    document.body.classList.add('printing')

    requestAnimationFrame(() => {
      resizeAllCharts()
      setTimeout(() => {
        window.print()
        document.body.classList.remove('printing')
        requestAnimationFrame(() => resizeAllCharts())
      }, 50)
    })
  }

  return (
    <button
      title="PDF"
      className="button print-button"
      type="button"
      onClick={handlePrint}
    >
      <span className="icon icon-download" />
    </button>
  )
}
